import { Box, Typography } from "@mui/material";
import { string, number } from "prop-types";
import React from "react";
import CustomButton from "../common/CustomButton";

export default function Product({
  name = "",
  image = "",
  price = 0,
  handleBuyNow = () => {},
}) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      sx={{
        maxWidth: 346,
        minWidth: 312,
        width: "100%",
      }}
      gap={2}
    >
      <img
        style={{ backgroundColor: "#191922" }}
        height={236}
        width="100%"
        src={image}
        alt="img-product"
      />
      <Typography variant="body2">{name}</Typography>
      <Typography variant="caption" color="#FFC831">
        {price}$
      </Typography>
      <CustomButton handleClick={handleBuyNow}>Buy Now</CustomButton>
    </Box>
  );
}

Product.propTypes = {
  name: string,
  image: string,
  price: number,
};
